'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (method) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var result = {},
        queryParams = this.queryParams;


    if (typeof queryParams !== 'undefined' && typeof queryParams[method] === 'function') {
        result = queryParams[method].call(this, data);
    } else {
        if (process && process.env.NODE_ENV !== 'production') {
            console.error('Sync. QueryParams fro method ' + method + ' is undefined');
        }
    }

    return result;
};